export const environment = {
  production: true,
  apiUrl: 'https://sky-mpi-prod-finance-fa-suppliersearch.azurewebsites.net/api/suppliers',
  functionKey: 'cXei41b17H2QAHbLaE1188ftOq4Tu4ScSM6YaKhtHNGGAzFuhhOgGQ==',
  appUrl:'https://sky.supplier.middleware.sky'
};
